// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__kJhX2","emptyCart":"Cart_emptyCart__cyaTy"};